import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=7e12144d"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e12144d')) {
      api.createRecord('7e12144d', component.options)
    } else {
      api.reload('7e12144d', component.options)
    }
    module.hot.accept("./Reviews.vue?vue&type=template&id=7e12144d", function () {
      api.rerender('7e12144d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/Reviews.vue"
export default component.exports